module.exports = __webpack_public_path__ + "img/click-touch.f2d9676f.svg";